import { render, staticRenderFns } from "./UnpaidLeaves.vue?vue&type=template&id=1dca9122&"
import script from "./UnpaidLeaves.vue?vue&type=script&lang=js&"
export * from "./UnpaidLeaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports